import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { If, Unless, Text, Avatar } from 'src/Components'
import {
  selectCustomerHasSponsor,
  selectHasMortgageCoach,
  selectCustomerFirstName,
  selectCustomerPhotoUri
} from 'src/store/selectors/customerProfile'
import {
  selectSponsorshipFullName,
  selectSponsorshipPhotoUri
} from 'src/store/selectors/sponsorship'

import RefiRequestButton from './RefiRequestButton'
import MortgageCoachRequestButton from './MortgageCoachRequestButton'

import styles from './RefiDetailsOutreach.module.scss'

export const RefiDetailsOutreach = ({ details }) => {
  const hasSponsor = useSelector(selectCustomerHasSponsor)
  const hasMortgageCoach = useSelector(selectHasMortgageCoach)

  return (
    <div
      className={classnames(styles.outreach, hasSponsor && styles.withAvatars)}
    >
      <If condition={hasSponsor}>
        <CospoAvatars />
        <CospoCopy />
      </If>
      <Unless condition={hasSponsor}>
        <Text color='quiet' size='s'>
          <FormattedMessage
            id='Refinance.details.outrech.standard.nocospo'
            defaultMessage='These are {estimates} based on national rate trends. Your rate can change if you have different refi goals or credit score.'
            values={{
              estimates: (
                <Text element='span' color='white'>
                  <FormattedMessage
                    id='Refinance.details.outrech.standard.estimated'
                    defaultMessage='estimated'
                  />
                </Text>
              )
            }}
          />
        </Text>
      </Unless>
      <If condition={hasMortgageCoach}>
        <MortgageCoachRequestButton {...details} />
      </If>
      <Unless condition={hasMortgageCoach}>
        <RefiRequestButton {...details} />
      </Unless>
    </div>
  )
}

export const CospoAvatars = () => {
  const customerPhotoUri = useSelector(selectCustomerPhotoUri)
  const sponsorPhotoUri = useSelector(selectSponsorshipPhotoUri)

  return (
    <div className={styles.avatars}>
      <Avatar src={customerPhotoUri} className={styles.avatar} />
      <Avatar src={sponsorPhotoUri} className={styles.avatar} />
    </div>
  )
}

const CospoCopy = () => {
  const customerFirstName = useSelector(selectCustomerFirstName)
  const sponsorFullName = useSelector(selectSponsorshipFullName)

  return (
    <Text color='quiet' size='s'>
      <FormattedMessage
        id='Refinance.details.outrech.standard.cospo'
        defaultMessage='These are estimates based on national rate trends. {customer} recommends {sponsor}, a trusted lender, to get a quick customized rate check.'
        values={{
          customer: customerFirstName,
          sponsor: (
            <Text element='span' color='white'>
              {sponsorFullName}
            </Text>
          )
        }}
      />
    </Text>
  )
}

RefiDetailsOutreach.propTypes = {
  details: PropTypes.object
}

export default RefiDetailsOutreach
